import { render, staticRenderFns } from "./AddTeacherMap.vue?vue&type=template&id=367c0618&"
import script from "./AddTeacherMap.vue?vue&type=script&lang=js&"
export * from "./AddTeacherMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports